import { useEffect } from 'react';
import { setPageTitle } from '@hotjar/webapp/utils/document';

/**
 * Future person: this function has been re-exported by packages/subscription-management,
 * if you extract this out of webapp into a standalone util please inform `@hotjar/monetization-platform` or `@hotjar/billing` FE so they are aware
 */
export function usePageTitle(title = 'Hotjar'): void {
  useEffect(() => {
    const previousTitle = document.title;
    setPageTitle(title);

    return () => {
      setPageTitle(previousTitle);
    };
  }, [title]);
}
